import React from 'react';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';

export function TextMaskCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <MaskedInput
            {...other}
            guide={false}
            onChange={(event) => {
                props.inputRef.error = true
                onChange(event)
            }}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            placeholderChar={'\u2000'}
            showMask
        />
    );
}

TextMaskCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/TextMaskCustom.tsx